<script>
    import { getContext } from 'svelte';
    import { writable } from 'svelte/store';

    export let dataKey;
    export let projection;
    export let tooltip;
    const radius = 2;

    const {
        stops: keyed_stops,
        selector,
        car,
        enable_timeline,
        time_range,
        moving_time,
        geo_distance,
        poi_distance,
    } = getContext(dataKey);
    const { active_item, selected_item } = selector;
    const stops = writable([]);
    $: if (!$moving_time) {
        $stops = Object.keys($keyed_stops)
            .filter((key) => {
                const s = $keyed_stops[key];
                const pass_start = s.start.timestamp < $time_range[1];
                const pass_stop = s.stop.timestamp > $time_range[0];
                const pass_car = !$enable_timeline || s.car == $car;
                return pass_car && pass_start && pass_stop;
            })
            .map((key) => $keyed_stops[key]);
    }
    $: is_active = $stops.map((s) => {
        if ($selected_item) {
            const start_distance = geo_distance(
                s.start.lat,
                s.start.long,
                $selected_item.lat,
                $selected_item.long
            );
            const stop_distance = geo_distance(
                s.stop.lat,
                s.stop.long,
                $selected_item.lat,
                $selected_item.long
            );
            return {
                start: start_distance < $poi_distance,
                stop: stop_distance < $poi_distance,
            };
        }
        const res = !$active_item || s._key == $active_item._key;
        return { start: res, stop: res };
    });

    $: start_coords = $stops.map((s) =>
        projection([s.start.long, s.start.lat])
    );
    $: stop_coords = $stops.map((s) => projection([s.stop.long, s.stop.lat]));
</script>

<g>
    {#each $stops as s, i}
        <path
            d={`M ${start_coords[i][0]} ${start_coords[i][1]} L ${stop_coords[i][0]} ${stop_coords[i][1]}`}
            fill="transparent"
            stroke={s.state === 'rejected' ? 'red' : 'currentColor'}
            opacity={is_active[i].start && is_active[i].stop ? 1 : 0}
            on:mouseenter={(e) => {
                $tooltip.start(e, s);
                selector.hover(s);
            }}
            on:mouseleave={() => {
                $tooltip.stop();
                selector.hover(null);
            }}
        />
        <circle
            cx={start_coords[i][0]}
            cy={start_coords[i][1]}
            r={radius}
            opacity={is_active[i].start ? 1 : 0.1}
            fill="#94d2bd"
            on:mouseenter={(e) => {
                $tooltip.start(e, s);
                selector.hover(s);
            }}
            on:mouseleave={() => {
                $tooltip.stop();
                selector.hover(null);
            }}
            on:click={() => selector.select(s.start)}
        />
        <circle
            cx={stop_coords[i][0]}
            cy={stop_coords[i][1]}
            r={radius}
            opacity={is_active[i].stop ? 1 : 0.1}
            fill="#ee9b00"
            on:mouseenter={(e) => {
                $tooltip.start(e, s);
                selector.hover(s);
            }}
            on:mouseleave={() => {
                $tooltip.stop();
                selector.hover(null);
            }}
            on:click={() => selector.select(s.stop)}
        />
    {/each}
</g>
